<div class="mx-auto max-w-6xl">
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Benutzer</h1>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Verwaltung der Office-Benutzer, Dienstnehmer (Feld-Erfasser) und Mobilgeräte.
    </p>
  </div>

  <mat-tab-group>
    <!-- ---------------------------------------------------------------- Office -->
    <mat-tab label="Office">
      <div class="grid grid-cols-1 gap-6 pt-4 lg:grid-cols-3">
        <div class="lg:col-span-2">
          <div class="rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
              <h2 class="text-sm font-semibold text-gray-900 dark:text-white">Web-Anwender</h2>
              <button
                type="button"
                (click)="newMitarbeiter()"
                class="rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-blue-700">
                Neu anlegen
              </button>
            </div>
            <div class="overflow-x-auto">
              <table class="w-full text-left text-sm text-gray-700 dark:text-gray-300">
                <thead class="bg-gray-50 text-xs uppercase text-gray-500 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th class="px-3 py-2">Name</th>
                    <th class="px-3 py-2">Login</th>
                    <th class="px-3 py-2">Rolle</th>
                    <th class="px-3 py-2">Dienstnehmer</th>
                    <th class="px-3 py-2">SU</th>
                    <th class="px-3 py-2">Aktiv</th>
                    <th class="px-3 py-2">Letzter Login</th>
                    <th class="px-3 py-2 text-right">Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="mitarbeiterLoading">
                    <td colspan="8" class="px-3 py-6 text-center text-gray-400">Laden...</td>
                  </tr>
                  <tr *ngIf="!mitarbeiterLoading && mitarbeiterList.length === 0">
                    <td colspan="8" class="px-3 py-6 text-center text-gray-400">Keine Office-Benutzer vorhanden.</td>
                  </tr>
                  <tr
                    *ngFor="let u of mitarbeiterList"
                    class="cursor-pointer border-b border-gray-100 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-700"
                    (click)="selectMitarbeiterForEdit(u)">
                    <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ u.name }}</td>
                    <td class="px-3 py-2">{{ u.login }}</td>
                    <td class="px-3 py-2">
                      <span [ngClass]="mitarbeiterRoleBadgeClasses(u)" class="rounded px-2 py-0.5 text-xs font-medium">
                        {{ u.role_name }}
                      </span>
                    </td>
                    <td class="px-3 py-2">{{ u.dienstnehmer_name || dienstnehmerNameFor(u.f_id) }}</td>
                    <td class="px-3 py-2">
                      <span
                        [ngClass]="u.su === 1 ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-600'"
                        class="rounded px-2 py-0.5 text-xs font-medium">
                        {{ u.su === 1 ? 'Ja' : 'Nein' }}
                      </span>
                    </td>
                    <td class="px-3 py-2">
                      <span
                        [ngClass]="u.active === 1 ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-600'"
                        class="rounded px-2 py-0.5 text-xs font-medium">
                        {{ u.active === 1 ? 'Ja' : 'Nein' }}
                      </span>
                    </td>
                    <td class="px-3 py-2 whitespace-nowrap text-xs text-gray-500">{{ formatLastSeen(u.lastlogin) }}</td>
                    <td class="px-3 py-2 text-right">
                      <button
                        type="button"
                        (click)="$event.stopPropagation(); deactivateMitarbeiter(u)"
                        class="rounded bg-red-100 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-200">
                        Deaktivieren
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="lg:col-span-1">
          <div class="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <h2 class="mb-3 text-sm font-semibold text-gray-900 dark:text-white">
              {{ mitarbeiterEdit.id ? 'Bearbeiten' : 'Neu anlegen' }}
            </h2>
            <div class="space-y-3">
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Name</label>
                <input
                  type="text"
                  [(ngModel)]="mitarbeiterEdit.name"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Login</label>
                <input
                  type="text"
                  [(ngModel)]="mitarbeiterEdit.login"
                  autocomplete="username"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">E-Mail</label>
                <input
                  type="email"
                  [(ngModel)]="mitarbeiterEdit.email"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
                  Kennwort {{ mitarbeiterEdit.id ? '(leer = unverändert)' : '' }}
                </label>
                <input
                  type="password"
                  [(ngModel)]="mitarbeiterEdit.pwd"
                  autocomplete="new-password"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Benutzergruppe</label>
                <select
                  [(ngModel)]="mitarbeiterEdit.beusergroup_id"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white">
                  <option *ngFor="let r of webRoleOptions" [ngValue]="r.value">{{ r.label }}</option>
                </select>
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Verknüpfter Dienstnehmer</label>
                <select
                  [(ngModel)]="mitarbeiterEdit.f_id"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white">
                  <option [ngValue]="0">– Kein Dienstnehmer –</option>
                  <option *ngFor="let dn of list" [ngValue]="dn.id">{{ dn.name }} ({{ dn.dienstnummer }})</option>
                </select>
                <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                  Optional: Verknüpfung mit einem Feld-Dienstnehmer (f_id).
                </p>
              </div>
              <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <input
                  type="checkbox"
                  [checked]="mitarbeiterEdit.admin === 1"
                  (change)="mitarbeiterEdit.admin = $any($event.target).checked ? 1 : 0" />
                Admin (admin)
              </label>
              <label class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                <input
                  type="checkbox"
                  disabled
                  [checked]="mitarbeiterEdit.su === 1" />
                Superuser-Flag (su) — nur Anzeige
              </label>
              <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <input
                  type="checkbox"
                  [checked]="mitarbeiterEdit.active === 1"
                  (change)="mitarbeiterEdit.active = $any($event.target).checked ? 1 : 0" />
                Aktiv
              </label>
              <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <input
                  type="checkbox"
                  [checked]="mitarbeiterEdit.isapproved === 1"
                  (change)="mitarbeiterEdit.isapproved = $any($event.target).checked ? 1 : 0" />
                Freigeschaltet (isapproved)
              </label>
              <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <input
                  type="checkbox"
                  [checked]="mitarbeiterEdit.isactivated === 1"
                  (change)="mitarbeiterEdit.isactivated = $any($event.target).checked ? 1 : 0" />
                Aktiviert (isactivated)
              </label>
              <div class="flex gap-2 pt-2">
                <button
                  type="button"
                  (click)="saveMitarbeiter()"
                  [disabled]="mitarbeiterSaving"
                  class="flex-1 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 disabled:opacity-50">
                  {{ mitarbeiterSaving ? 'Speichern...' : 'Speichern' }}
                </button>
                <button
                  type="button"
                  (click)="newMitarbeiter()"
                  class="rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300">
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- ---------------------------------------------------------------- Dienstnehmer -->
    <mat-tab label="Dienstnehmer">
      <div class="grid grid-cols-1 gap-6 pt-4 lg:grid-cols-3">
        <!-- list -->
        <div class="lg:col-span-2">
          <div class="rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
              <h2 class="text-sm font-semibold text-gray-900 dark:text-white">Liste</h2>
              <button
                type="button"
                (click)="newDienstnehmer()"
                class="rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-blue-700">
                Neuer Dienstnehmer
              </button>
            </div>
            <div class="overflow-x-auto">
              <table class="w-full text-left text-sm text-gray-700 dark:text-gray-300">
                <thead class="bg-gray-50 text-xs uppercase text-gray-500 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th class="px-3 py-2">Name</th>
                    <th class="px-3 py-2">Dienstnr.</th>
                    <th class="px-3 py-2">STVO</th>
                    <th class="px-3 py-2">Gruppe</th>
                    <th class="px-3 py-2">Geräte</th>
                    <th class="px-3 py-2">Aktiv</th>
                    <th class="px-3 py-2 text-right">Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="loading">
                    <td colspan="7" class="px-3 py-6 text-center text-gray-400">Laden...</td>
                  </tr>
                  <tr *ngIf="!loading && list.length === 0">
                    <td colspan="7" class="px-3 py-6 text-center text-gray-400">Keine Dienstnehmer vorhanden.</td>
                  </tr>
                  <tr
                    *ngFor="let dn of list"
                    class="cursor-pointer border-b border-gray-100 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-700"
                    (click)="selectForEdit(dn)">
                    <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ dn.name }}</td>
                    <td class="px-3 py-2">{{ dn.dienstnummer }}</td>
                    <td class="px-3 py-2">{{ dn.dienstnummer_stvo }}</td>
                    <td class="px-3 py-2">
                      <span [ngClass]="groupBadgeClasses(dn.benutzergruppe)" class="rounded px-2 py-0.5 text-xs font-medium">
                        {{ groupLabel(dn.benutzergruppe) }}
                      </span>
                    </td>
                    <td class="px-3 py-2 text-gray-600">{{ deviceCountFor(dn.dienstnummer) }}</td>
                    <td class="px-3 py-2">
                      <span
                        [ngClass]="dn.active === 1 ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-600'"
                        class="rounded px-2 py-0.5 text-xs font-medium">
                        {{ dn.active === 1 ? 'Ja' : 'Nein' }}
                      </span>
                    </td>
                    <td class="px-3 py-2 text-right">
                      <button
                        type="button"
                        (click)="$event.stopPropagation(); remove(dn)"
                        class="rounded bg-red-100 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-200">
                        Löschen
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- form -->
        <div class="lg:col-span-1">
          <div class="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <h2 class="mb-3 text-sm font-semibold text-gray-900 dark:text-white">
              {{ edit.id ? 'Bearbeiten' : 'Neu anlegen' }}
            </h2>

            <div class="space-y-3">
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Name</label>
                <input
                  type="text"
                  [(ngModel)]="edit.name"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Dienstnummer</label>
                  <input
                    type="number"
                    [(ngModel)]="edit.dienstnummer"
                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
                </div>
                <div>
                  <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Dienstnr. STVO</label>
                  <input
                    type="number"
                    [(ngModel)]="edit.dienstnummer_stvo"
                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
                </div>
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Benutzergruppe</label>
                <select
                  [(ngModel)]="edit.benutzergruppe"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white">
                  <option *ngFor="let r of roleOptions" [ngValue]="r.value">{{ r.label }}</option>
                </select>
                <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                  Feld-Erfasser (Mobile-App) verwenden in der Regel <strong>Organ ({{ roleOrgan }})</strong>.
                </p>
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Sachbereich</label>
                <input
                  type="text"
                  [(ngModel)]="edit.sachbereich"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
                  Kennwort {{ edit.id ? '(leer = unverändert)' : '' }}
                </label>
                <input
                  type="password"
                  [(ngModel)]="edit.kennwort"
                  autocomplete="new-password"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <input type="checkbox" [checked]="edit.active === 1" (change)="edit.active = $any($event.target).checked ? 1 : 0" />
                Aktiv
              </label>

              <div class="flex gap-2 pt-2">
                <button
                  type="button"
                  (click)="save()"
                  [disabled]="saving"
                  class="flex-1 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 disabled:opacity-50">
                  {{ saving ? 'Speichern...' : 'Speichern' }}
                </button>
                <button
                  type="button"
                  (click)="newDienstnehmer()"
                  class="rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300">
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- ---------------------------------------------------------------- Geräte -->
    <mat-tab label="Geräte">
      <div class="grid grid-cols-1 gap-6 pt-4 lg:grid-cols-3">
        <!-- list -->
        <div class="lg:col-span-2 space-y-4">
          <div
            *ngIf="!devicesLoading && pendingDevices.length > 0"
            class="rounded-xl border border-amber-200 bg-amber-50 p-4 shadow-sm dark:border-amber-800 dark:bg-amber-900/20">
            <h2 class="mb-2 text-sm font-semibold text-amber-900 dark:text-amber-200">
              Ausstehende Registrierungen ({{ pendingDevices.length }})
            </h2>
            <p class="mb-3 text-xs text-amber-800 dark:text-amber-300">
              Diese Telefone haben sich selbst registriert und warten auf Freischaltung.
            </p>
            <div class="space-y-2">
              <div
                *ngFor="let d of pendingDevices"
                class="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-amber-200 bg-white px-3 py-2 dark:border-amber-700 dark:bg-gray-800">
                <div>
                  <div class="font-medium text-gray-900 dark:text-white">{{ d.phone_id }}</div>
                  <div class="text-xs text-gray-500">{{ d.label || 'Keine Bezeichnung' }} · {{ formatLastSeen(d.created) }}</div>
                </div>
                <div class="flex gap-1">
                  <button
                    type="button"
                    (click)="selectDeviceForEdit(d)"
                    class="rounded bg-gray-200 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-300">
                    Zuweisen
                  </button>
                  <button
                    type="button"
                    (click)="toggleDeviceActive(d)"
                    class="rounded bg-green-600 px-2 py-1 text-xs font-medium text-white hover:bg-green-700">
                    Aktivieren
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
              <h2 class="text-sm font-semibold text-gray-900 dark:text-white">Registrierte Geräte / Telefone</h2>
              <button
                type="button"
                (click)="newDevice()"
                class="rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-blue-700">
                Neues Gerät
              </button>
            </div>
            <div class="overflow-x-auto">
              <table class="w-full text-left text-sm text-gray-700 dark:text-gray-300">
                <thead class="bg-gray-50 text-xs uppercase text-gray-500 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th class="px-3 py-2">Phone-ID</th>
                    <th class="px-3 py-2">Bezeichnung</th>
                    <th class="px-3 py-2">Dienstnr.</th>
                    <th class="px-3 py-2">Zuletzt</th>
                    <th class="px-3 py-2">Status</th>
                    <th class="px-3 py-2 text-right">Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="devicesLoading">
                    <td colspan="6" class="px-3 py-6 text-center text-gray-400">Laden...</td>
                  </tr>
                  <tr *ngIf="!devicesLoading && managedDevices.length === 0">
                    <td colspan="6" class="px-3 py-6 text-center text-gray-400">Keine Geräte registriert.</td>
                  </tr>
                  <tr
                    *ngFor="let d of managedDevices"
                    class="cursor-pointer border-b border-gray-100 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-700"
                    (click)="selectDeviceForEdit(d)">
                    <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ d.phone_id }}</td>
                    <td class="px-3 py-2">{{ d.label || '–' }}</td>
                    <td class="px-3 py-2">{{ dienstnehmerLabelFor(d.dienstnummer) }}</td>
                    <td class="px-3 py-2 whitespace-nowrap text-xs text-gray-500">{{ formatLastSeen(d.last_seen) }}</td>
                    <td class="px-3 py-2">
                      <span [ngClass]="deviceStatusClasses(d)" class="rounded px-2 py-0.5 text-xs font-medium">
                        {{ deviceStatusLabel(d) }}
                      </span>
                    </td>
                    <td class="px-3 py-2 text-right">
                      <div class="flex justify-end gap-1">
                        <button
                          type="button"
                          (click)="$event.stopPropagation(); toggleDeviceActive(d)"
                          class="rounded bg-gray-200 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-300">
                          {{ deviceToggleLabel(d) }}
                        </button>
                        <button
                          type="button"
                          (click)="$event.stopPropagation(); removeDevice(d)"
                          class="rounded bg-red-100 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-200">
                          Löschen
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- form -->
        <div class="lg:col-span-1">
          <div class="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <h2 class="mb-3 text-sm font-semibold text-gray-900 dark:text-white">
              {{ deviceEdit.id ? 'Gerät bearbeiten' : 'Gerät hinzufügen' }}
            </h2>
            <div class="space-y-3">
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Phone-ID</label>
                <input
                  type="text"
                  [(ngModel)]="deviceEdit.phone_id"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Bezeichnung</label>
                <input
                  type="text"
                  [(ngModel)]="deviceEdit.label"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Dienstnehmer (optional)</label>
                <select
                  [(ngModel)]="deviceEdit.dienstnummer"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white">
                  <option [ngValue]="null">– Kein Dienstnehmer –</option>
                  <option *ngFor="let dn of activeDienstnehmer" [ngValue]="dn.dienstnummer">
                    {{ dn.name }} ({{ dn.dienstnummer }})
                  </option>
                </select>
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
                  Token {{ deviceEdit.id ? '(leer = unverändert)' : '(leer = automatisch)' }}
                </label>
                <input
                  type="text"
                  [(ngModel)]="deviceEdit.token"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white" />
              </div>
              <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <input type="checkbox" [checked]="deviceEdit.active === 1" (change)="deviceEdit.active = $any($event.target).checked ? 1 : 0" />
                Aktiv
              </label>
              <div class="flex gap-2 pt-2">
                <button
                  type="button"
                  (click)="saveDevice()"
                  [disabled]="deviceSaving"
                  class="flex-1 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 disabled:opacity-50">
                  {{ deviceSaving ? 'Speichern...' : 'Speichern' }}
                </button>
                <button
                  type="button"
                  (click)="newDevice()"
                  class="rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300">
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
